// Sélection de comparaison persistée (sessionStorage), plafonnée. Pur (storage injecté).
export function createSelection(storage, max = 4, key = 'wb_cmp_sel') {
  const read = () => {
    try { const v = JSON.parse(storage.getItem(key) || '[]'); return Array.isArray(v) ? v : []; }
    catch { return []; }
  };
  const write = arr => storage.setItem(key, JSON.stringify(arr));
  return {
    list: () => read(),
    has: h => read().includes(h),
    isFull: () => read().length >= max,
    toggle: h => {
      const arr = read();
      const i = arr.indexOf(h);
      if (i >= 0) { arr.splice(i, 1); write(arr); return true; }
      if (arr.length >= max) return false;     // plafond
      arr.push(h); write(arr); return true;
    },
    remove: h => { const arr = read().filter(x => x !== h); write(arr); },
    clear: () => storage.removeItem(key),
  };
}
if (typeof window !== 'undefined') {
  window.WBCompare = Object.assign(window.WBCompare || {}, { createSelection });
}
